module.exports = __webpack_public_path__ + "images/marketing/peeps/chris_root.jpg";